export const FAQDetails = [
    {
        "question": "What subjects are covered on the website?",
        "answer": "Our website covers a wide range of subjects including mathematics, science, language arts, history, and more. We strive to provide comprehensive resources for students of all ages."
    },
    {
        "question": "Are the resources on the website free to access?",
        "answer": "Yes, all resources on our website are free to access. We believe in providing quality educational materials to everyone regardless of their financial circumstances."
    },
    {
        "question": "Do you offer interactive learning activities?",
        "answer": "Absolutely! We have a variety of interactive learning activities, quizzes, games, and simulations to engage students and enhance their learning experience."
    },
    {
        "question": "Is the content on the website suitable for different grade levels?",
        "answer": "Yes, our content is designed to cater to students from elementary school through high school and even beyond. We provide materials suitable for various grade levels and academic abilities."
    },
    {
        "question": "Can teachers use the website in their classrooms?",
        "answer": "Definitely! Teachers are welcome to use our website as a supplementary resource in their classrooms. We offer lesson plans, worksheets, and other teaching materials to support educators."
    },
    {
        "question": "How frequently is the website updated?",
        "answer": "We strive to update our website regularly with fresh content and new resources. Our team works diligently to ensure that our materials remain current and relevant to the needs of students and educators."
    }
];